import { createSlice } from "@reduxjs/toolkit";
import { cartProductCount, getCartProducts } from "../../reduxApi/website/CartProductCount";

const CartCountSlice = createSlice({
  name: "CartCount",
  initialState: {
    status: "idle",
    CartCount: 0, // Logged-in cart count
    guestCartCount: 0, // Guest cart count (localStorage)
    CartProducts: [],
    error: null,
  },
  reducers: {
    // Set full count from guest localStorage
    setGuestCartCount: (state, action) => {
      state.guestCartCount = action.payload;
    },
    // Increment guest cart count manually
    incrementGuestCartCount: (state) => {
      state.guestCartCount += 1;
    },
    // Reset on login/logout
    resetGuestCartCount: (state) => {
      state.guestCartCount = 0;
    },
    // decrement
    decrementGuestCartCount: (state) => {
      if (state.guestCartCount > 0) {
        state.guestCartCount -= 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cartProductCount.pending, (state) => {
        state.status = "pending";
      })
      .addCase(cartProductCount.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.CartCount = action.payload.data;
        // console.log("Backend Cart Count:", state.CartCount);
      })
      .addCase(getCartProducts.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.CartProducts = action.payload.data;
        // console.log("Cart Products from backend:", state.CartProducts);
      });
  },
});

export const { setGuestCartCount, incrementGuestCartCount, resetGuestCartCount, decrementGuestCartCount } = CartCountSlice.actions;

export default CartCountSlice.reducer;
